"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAlgoliaHit = transformAlgoliaHit;
exports.transformTreatmentHit = transformTreatmentHit;
exports.isTreatmentSearchResult = isTreatmentSearchResult;
exports.isProductSearchResult = isProductSearchResult;
exports.transformAlgoliaBrandHit = transformAlgoliaBrandHit;
/**
 * Transform Algolia hit to UI-friendly search result
 */
function transformAlgoliaHit(hit) {
    return {
        _type: 'product',
        id: hit.id,
        title: hit.title,
        fullTitle: hit.full_title,
        imageUrl: hit.image_url || '',
        brandName: hit.brand?.title || '',
        brandAlias: hit.brand?.alias || '',
        brandId: hit.brand?.id ? parseInt(hit.brand.id, 10) : undefined,
    };
}
/**
 * Transform Algolia treatment hit to UI-friendly search result
 */
function transformTreatmentHit(hit) {
    return {
        _type: 'treatment',
        id: hit.id,
        slug: hit.slug,
        name: hit.name,
        category: hit.category,
    };
}
/**
 * Type guard to check if an item is a TreatmentSearchResult
 */
function isTreatmentSearchResult(item) {
    return item._type === 'treatment';
}
/**
 * Type guard to check if an item is a ProductSearchResult
 */
function isProductSearchResult(item) {
    return item._type === 'product';
}
/**
 * Transform Algolia brand hit to simple format
 */
function transformAlgoliaBrandHit(hit) {
    return {
        id: hit.id,
        title: hit.title,
        alias: hit.alias,
    };
}
//# sourceMappingURL=pdb.js.map